import fs from 'node:fs';
import path from 'node:path';
import { INDEX_DIR } from '../../files/index/constants.js';
import { moveLegacyFileToOldVersionBackup } from './archive-to-old-version.js';

/** Move legacy `.file-index-*.json` from the BuildAutomaton data dir into `old-version/file-index/`. */
export function archiveLegacyFileIndexJsonFiles(): void {
  try {
    if (!fs.existsSync(INDEX_DIR)) return;
    for (const name of fs.readdirSync(INDEX_DIR)) {
      if (name.startsWith('.file-index-') && name.endsWith('.json')) {
        const full = path.join(INDEX_DIR, name);
        try {
          moveLegacyFileToOldVersionBackup('file-index', full);
        } catch (err) {
          console.error(`[cli-sqlite] legacy import: could not archive ${name}`, err);
        }
      }
    }
  } catch (e) {
    console.error('[cli-sqlite] legacy import: archive file-index json failed', e);
  }
}
